import { action, thunk, computed } from 'easy-peasy'
import { AxiosError } from 'axios'

import { FormStatus } from '@/types'

import { TrackDeliveryModel } from './type'
import { service } from './service'

export const trackDelivery: TrackDeliveryModel = {
	status: FormStatus.IDLE,
	data: null,
	message: '',
	error: '',

	/** Computed */
	loading: computed(state => state.status === FormStatus.LOADING),
	success: computed(state => state.status === FormStatus.SUCCESS),

	/** Actions */
	setStatus: action((state, payload) => {
		state.status = payload
	}),
	setData: action((state, payload) => {
		state.data = payload
	}),
	setMessage: action((state, payload) => {
		state.message = payload
	}),
	setError: action((state, payload) => {
		state.error = payload
	}),

	/** Thunks */
	track: thunk(async (action, payload) => {
		try {
			action.setStatus(FormStatus.LOADING)
			const res = await service.track(payload)
			action.setMessage(res.message)
			action.setData(res.data)
			action.setStatus(FormStatus.SUCCESS)
			return res.data
		} catch (e) {
			if (e instanceof AxiosError) {
				action.setStatus(FormStatus.ERROR)
				action.setError(
					e?.response?.data?.message ||
						(navigator.onLine ? 'Server Error' : 'Network Error')
				)
			}
		} finally {
			setTimeout(() => {
				action.setStatus(FormStatus.IDLE)
				action.setError('')
			}, 1)
		}
	})
}

